import script from "./CertificateSignatures.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateSignatures.vue?vue&type=script&setup=true&lang=js"

import "./CertificateSignatures.vue?vue&type=style&index=0&id=86c4d2d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86c4d2d6"]])

export default __exports__